import { Stack } from 'expo-router';

export default function GymIdLayout() {
  return <Stack screenOptions={{ headerShown: true }} />;
}
